<template>
    <zen-message-modal :isOpen="isOpen" title="Transfer ownership?">
        Transfer account ownership to <strong>{{ newOwnerName }}</strong
        >? You will be downgraded to the <strong>Admin</strong> role and will no
        longer be able to delete the account or transfer ownership yourself.
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                :disabled="processing"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary-danger"
                size="medium"
                :processing="processing"
                @click="$emit('confirm')"
                data-testid="confirm-transfer-ownership-button"
            >
                Transfer Ownership
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'TransferOwnershipModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        newOwnerName: {
            type: String,
            default: '',
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
